var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPdfUrl())?_c('div',[_c('a',{staticClass:"rc-input-button-nopadding rc-input-width",attrs:{"href":_vm.pdfUrl(),"target":"_blank"}},[_vm._v("PDF")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }